import React, { useState ,useEffect} from "react";
import Slider from "react-slick";
import ReactPlayer from 'react-player';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../../../scss/components/GenericBanner/slider.scss"
import style from '../../../scss/components/GenericBanner/slider';
import SafeHTML from "../SafeHTML";
import YouTubeLogo from "../../../img/youtube.svg"

const SimpleSlider = (props) => {
    const [isPopupOpen, setPopupOpen] = useState(false);
    const [videoUrl, setVideoUrl] = useState('');
    const [isColorFlexL2Page, setIsColorFlexL2Page] = useState(false);


    const openPopup = (url) => {
        if (url.toLowerCase().includes("youtube")) {
            setPopupOpen(true);
            setVideoUrl(url);
        } else {
            window.open(url);
        }
    };


    useEffect(()=>{
        let isColorFlexL2 = window.location.pathname.includes("colorflex-l2")
        if(isColorFlexL2){
            setIsColorFlexL2Page(isColorFlexL2)  
        }

    }, [])
    const closePopup = () => {
        setPopupOpen(false);
    };

    var settings = {
        dots: false,
        infinite: true,
        speed: 1500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5500,
        pauseOnHover: true,
        pauseOnFocus: true,
    };
    let slider = props.sliderData


    return (
        !window.location.pathname.includes("products") ?
            <div>
                <Slider {...settings}>
                    {
                        slider.map((sliderData, index) => {
                            return (
                                <div className='image-container' key={index} >
                                    {/* <a style={{'width':'100%','height':'100%'}} href={sliderData.href}> */}
                                    <img
                                        onClick={() => openPopup(sliderData.href)}
                                        src={sliderData.url}
                                        alt={sliderData.alt}
                                        className='image-view'
                                        height="700"
                                        width="1920"
                                    />
                                    {/* </a> */}
                                </div>
                            )
                        })
                    }
                </Slider>
                {isPopupOpen && (
                    <div className="video-popup" onClick={closePopup}>
                        <div className="popup-content">
                            <div class="video-container">
                                <iframe
                                    title="Video Popup"
                                    width="560"
                                    height="315"
                                    src={videoUrl}
                                    frameborder="0"
                                    allowfullscreen
                                ></iframe>
                            </div>
                            
                        </div>
                        <b className="close-btn"><span className="close-btn-span">×</span></b>
                    </div>
                )}
            </div>
            :
            <div>
                <Slider {...settings}>
                    {
                        slider.map((sliderData, index) => {
                            return (
                                <div className='product-image-container' key={index} >
                                    <div
                                        className={isColorFlexL2Page ? "product-bg-banner colorflex-l2-bg-banner":"product-bg-banner "}
                                        onClick={() => openPopup(sliderData.href)}
                                        alt={sliderData.alt}
                                        style={{
                                            backgroundImage: `url(${sliderData.url})`,
                                            backgroundSize: 'cover',
                                            backgroundPosition: 'center',
                                            // height: '300px',
                                        }}
                                    >

                                        <img className="product-img-small" src={props.bannerData?.image?.url} style={{ height: "80%" }} />

                                        <div className="banner-left-content-data">
                                            <div className="yt-banner-text">
                                                <SafeHTML>{props.bannerData?.description}</SafeHTML>
                                            </div>
                                            <span className="watch-now-yt">
                                                <img style={{
                                                    height: "40px", display: "inline",
                                                }} src={YouTubeLogo} alt="youtube-logo" />
                                                <span style={{fontWeight:"bold"}}>{props.bannerData?.header}</span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                    }
                </Slider>
                {isPopupOpen && (
                    <div className="video-popup" onClick={closePopup}>
                        <div className="popup-content">
                            <div class="video-container">
                                <iframe
                                    title="Video Popup"
                                    width="560"
                                    height="315"
                                    src={videoUrl}
                                    frameborder="0"
                                    allowfullscreen
                                ></iframe>
                            </div>
                            
                        </div>
                        <b className="close-btn"><span className="close-btn-span">×</span></b>
                    </div>
                )}
            </div>
    );
}

export default SimpleSlider;